import {useState} from 'react'

import styles from './ProjectScheduleStats.module.scss'
import {useGetRequestLineFeeSchedule} from 'modules/request'
import {MeterStat, Button, CentsMoney, Dropdown} from 'common/components'
import {ScheduleChart} from '.'
import {
  formatMoney,
  formatDate,
  countPercentage,
  createReport,
} from 'common/helpers'
import {
  TRANSACTION_NAME,
  Transaction,
} from '..'

export default function ProjectScheduleStats({project, schedule}: any) {
  const [lineFeeReportSelect, setLineFeeReportSelect] = useState(false)
  const {
    data: requestLineFeeSchedule,
    isRefetching: isRequestLineFeeScheduleRefetching,
  } = useGetRequestLineFeeSchedule(
    project.loanRequests[0].uuid,
    lineFeeReportSelect,
    (lineFeeSchedule: any) => {
      createReport(
        getReportData(lineFeeSchedule),
        'Line Fee Calculation Schedule',
        'line-fee-calculation-report'
      )
    }
  )

  const handleReportMenuClick = ({key}: any) => {
    if (key === 'schedule')
      return createReport(
        getReportData(schedule),
        'Loan Schedule',
        'loan-schedule-report'
      )
    lineFeeReportSelect
      ? createReport(
          getReportData(requestLineFeeSchedule),
          'Line Fee Calculation Schedule',
          'line-fee-calculation-report'
        )
      : setLineFeeReportSelect(true)
  }

  let reportMenuItems = [
    {key: 'schedule', label: 'Loan Schedule'},
    {key: 'lineFeeSchedule', label: 'Line Fee Calculation Schedule'},
  ]
 
  // 2024.07之前导入的项目不显示Line Fee Calculation Schedule
  if (!project.isShowExportLineFee) {
    reportMenuItems.pop()
  }

  return (
    <div className={styles.root}>
      <div className={styles.stats}>
        <MeterStat
          large
          type="green"
          title="Current balance"
          value={<CentsMoney value={project.balance} />}
          label={`${formatMoney(project.availableBalance, {
            cents: true,
          })} available`}
        />
        <MeterStat
          greyTitle
          large
          type="dotsGreen"
          title="Accrued interest"
          value={<CentsMoney value={project.accruedInterest} />}
          label="&nbsp;"
        />
        <ScheduleChart project={project} />
        <MeterStat
          large
          right
          type="grey"
          title="Facility limit 2"
          value={<CentsMoney value={project.facilityLimit2} />}
          label="including interest & fees"
        />
        <MeterStat
          large
          right
          type="darkGreen"
          title="Repayments"
          value={<CentsMoney value={project.repaid} />}
          label={`${countPercentage(
            project.repaid,
            project.facilityLimit1, 2
          ).toFixed(2)}% repaid`}
        />
      </div>
      <Dropdown
        menu={{
          items: reportMenuItems,
          onClick: handleReportMenuClick,
        }}
        placement="bottomRight"
      >
        <Button
          dropdown
          loading={isRequestLineFeeScheduleRefetching}
          disabled={!schedule.length}
        >
          Create report
        </Button>
      </Dropdown>
    </div>
  )
}

const getReportData = (data: any[]) =>
  data.map((item, index) => ({
    '#': index + 1,
    Transaction: TRANSACTION_NAME[item.type as Transaction],
    Date: formatDate(item.date),
    Amount: item.value,
    Balance: item.balanceAfter,
    Notes: item.notes,
  }))
